import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class Erc20PaymentProcessingResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("Erc20PaymentProcessingResourcePackage");
    }
    public get assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/erc_20_payment_processing/erc_20_payment_processing_1x.atlas.json");
    }
    public get assets_views_erc_20_payment_processing_bg_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["bg.png"];
    }
    public get assets_views_erc_20_payment_processing_payment_method_bg_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["payment_method_bg.png"];
    }
    public get assets_views_erc_20_payment_processing_divider_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["divider.png"];
    }
    public get assets_views_erc_20_payment_processing_select_btn_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["select_btn.png"];
    }
    public get assets_views_erc_20_payment_processing_internal_wallet_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["internal_wallet.png"];
    }
    public get assets_views_erc_20_payment_processing_apple_pay_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["apple-pay.png"];
    }
    public get assets_views_erc_20_payment_processing_cc_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["cc.png"];
    }
    public get assets_views_erc_20_payment_processing_google_pay_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["google-pay.png"];
    }
    public get assets_views_erc_20_payment_processing_exteral_wallet_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["exteral_wallet.png"];
    }
    public get assets_views_erc_20_payment_processing_mon_icon_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["mon_icon.png"];
    }
    public get assets_views_erc_20_payment_processing_usdc_icon_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["usdc_icon.png"];
    }
    public get assets_views_erc_20_payment_processing_copy_icon_png(): Texture {
        return this.assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_json.textures["copy_icon.png"];
    }
    public get assets_views_erc_20_payment_processing_erc_20_payment_processing_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/erc_20_payment_processing/erc_20_payment_processing_1x.atlas.png");
    }
}

